import { render } from "./EmbedEducationsView.vue?vue&type=template&id=4f68e69d"
import script from "./EmbedEducationsView.vue?vue&type=script&lang=js"
export * from "./EmbedEducationsView.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/vhosts/tools.planval.ch/tools.planval.ch/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__